// extracted by mini-css-extract-plugin
export default {"root":"_Spgwh0XlZJEyaPztwWa","wrap":"yvHvq5_8SY9LGRfTLZqR","back":"_yX5oINYgsYKXj1oRjHK","title":"L0XsJIl2npOhPPoagie4","btns":"P5iWeaovKl7aKUAi9S_N","save":"w_yUQPiRpIAL1JtpsYkz"};